<!--
 * @Author: DQL
 * @Date: 2022-04-09 14:38:12
 * @LastEditors: DQL
 * @LastEditTime: 2022-07-01 14:52:32
 * @Description: file content
-->
<template>
  <hm-tree-select
    class="c-form__hm-treeselect c-tree-select-wrap"
    instance-id="DeptTreeSelect"
    placeholder="请选择机构"
    loading-text="加载中..."
    retry-text="重新加载"
    retry-title="点击重新加载"
    no-children-text="没有子节点"
    no-options-text="没有可用选项"
    no-results-text="没有匹配的结果"
    search-prompt-text="查找中..."
    :append-to-body="true"
    :load-options="handleLoadOptions"
    :options="optionsList"
    :normalizer="normalizer"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'AsyncDeptTree',
  props: {
    // 自动初始化数据
    autoInit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loadOptions: null,
      /* 下拉树展示的选项 Start */
      optionsList: [
      ]
      /* 下拉树展示的选项 End */
    };
  },
  methods: {
    /**
     * @description: 转换下拉树节点字段
     * @param {type}
     * @return:
     */
    normalizer (node) {
      return {
        id: node.deptCode,
        label: node.deptName,
        children: node.xjbz ? node.children : undefined
      };
    },
    /**
     * @description: 异步加载子节点
     * @param {*} action
     * @param {*} parentNode
     * @param {*} callback
     * @return {*}
     */
    handleLoadOptions ({ action, parentNode, callback }) {
      const serviceUrl = `${this.$config.commontCtx}/dept/tree/async?deptCode=${parentNode.deptCode}`;
      this.$axios.get(serviceUrl)
        .then(rsp => {
          parentNode.children = rsp.data.map(item => {
            return {
              ...item,
              children: item.xjbz ? null : undefined
            };
          });
          callback();
        })
        .catch(err => {
          callback(new Error('税务机构部门加载失败！', err));
        })
        .finally(() => {});
    },
    /**
     * @description: 初始化异步树第一层下拉数据
     * @param {*}
     * @return {*}
     */
    handleInitTree () {
      const serviceUrl = `${this.$config.commontCtx}/dept/tree/async`;
      this.$axios.get(serviceUrl)
        .then(rsp => {
          this.optionsList = rsp.data.map(item => {
            return {
              ...item,
              children: item.xjbz ? null : undefined
            };
          });
          if (this.autoInit && !this.$attrs.value) {
            this.$emit('input', this.$attrs.multiple ? [rsp.data[0].nodeCode] : rsp.data[0].nodeCode);
          }
        });
    }
  },
  created () {
    this.handleInitTree();
  }
};
</script>
